import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/container/Home';
import TestDetail from '@/container/TestDetail';
import TypeformTest from '@/container/TypeformTest';
import TypeformResult from '@/container/TypeformResult';
import PrivacyPolicy from '@/container/PrivacyPolicy';
import Instagram from '@/container/Instagram';

import Admin from '@/container/Admin';
import Login from '@/container/admin/Login';
import Tests from '@/container/admin/test/Tests';
import Typeforms from '@/container/admin/typeform/Typeforms';
import Languages from '@/container/admin/language/Languages';

import PageNotFound from '@/container/404';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/test/:id',
      name: 'TestDetail',
      component: TestDetail,
    },
    {
      path: '/test/:id/start',
      name: 'TypeformTest',
      component: TypeformTest,
    },
    {
      path: '/test/:id/result',
      name: 'TypeformResult',
      component: TypeformResult,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
    },
    {
      path: '/instagram',
      name: 'Instagram',
      component: Instagram,
    },
    // admin pages
    {
      path: '/admin/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {
        isAuthNeeded: true,
      },
    },
    {
      path: '/admin/tests',
      name: 'AdminTests',
      component: Tests,
      meta: {
        isAuthNeeded: true,
      },
    },
    {
      path: '/admin/typeforms',
      name: 'AdminTypeforms',
      component: Typeforms,
      meta: {
        isAuthNeeded: true,
      },
    },
    {
      path: '/admin/languages',
      name: 'AdminLanguages',
      component: Languages,
      meta: {
        isAuthNeeded: true,
      },
    },
    {
      path: '*',
      component: PageNotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // get jwt token from localStorage
  const jwtToken = localStorage.getItem('jwtToken');

  // if auth is needed and user has no token
  if (to.meta.isAuthNeeded && !jwtToken) next('/admin/login');

  // if user has token and he is trying to access login page
  if (to.path === '/admin/login' && jwtToken) next('/admin');

  // otherwise
  next();
});

export default router;
